import script from "./AddTransactionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddTransactionModal.vue?vue&type=script&setup=true&lang=js"

import "./AddTransactionModal.vue?vue&type=style&index=0&id=7424397b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7424397b"]])

export default __exports__